// Shared with external embeds without importing the player or API client.
let active = false;
let visible = false;
const listeners = new Set();
const visibilityListeners = new Set();
export const previewActivity = {
  getVisibility: () => visible,
  subscribeVisibility: (listener) => {
    visibilityListeners.add(listener);
    return () => visibilityListeners.delete(listener);
  },
  setVisible(value) {
    if (visible === value) return;
    visible = value;
    visibilityListeners.forEach((listener) => listener());
  },
  getSnapshot: () => active,
  subscribe: (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  set(value) {
    if (active === value) return;
    active = value;
    listeners.forEach((listener) => listener());
  },
};
